<template>
    <!-- 활성화 -->
    <div class="selectbox" :class="[isOpen ? 'selected--active' : '', props.isDisable ? 'selectbox__disabled' : '']" ref="dropdownContainer">
        <!-- 상단 클릭, 비활성화 상태일 때는 클릭 이벤트 방지 -->
        <p class="selected" @click="props.isDisable ? null : onOuter()" :class="[props.isDisable ? 'selectbox__p-disable' : '']">{{ props.current.label }}</p>
        <ul class="innerDiv" :class="[isOpen ? 'ulOpen' : 'ulClose']" @click.stop>
            <template v-for="(e, i) in props.liList" :key="i">
                <!-- 내부 클릭, 비활성화 상태일 때는 클릭 이벤트 방지 -->
                <!-- 진단평가의 경우 클릭시 리스트에 [0]선택 부분은 비노출, 그외 노출 -->
                <div v-if="whichType === 'eval' && i >= 1">
                    <li class="option" @click="props.isDisable ? null : onInner(i)">{{ e.label }}</li>
                </div>
                <div v-else-if="whichType !== 'eval'">
                    <li class="option" @click="props.isDisable ? null : onInner(i)">{{ e.label }}</li>
                </div>
            </template>
        </ul>
    </div>
    <!-- 닫기 -->
    <div class="selectbox__background" v-if="whichType !== 'eval' && isOpen" @click="props.isDisable ? null : onClose"></div>
</template>

<script setup>
import { onMounted, ref, defineEmits, defineProps, onBeforeUnmount } from 'vue';

const props = defineProps({
    liList: {
        type: Array,
        default: [{ value: 'ALL', label: '전체' }],
        required: true,
    },
    current: {
        type: Object,
        default: { value: 'ALL', label: '전체' },
        required: true,
    },
    isDisable: {
        type: Boolean,
        default: false,
    },
    whichType: {
        type: String,
        default: '',
        required: false,
    },
});

const emit = defineEmits(['onReturn', 'update:current']);

const dropdownContainer = ref(null);
const isOpen = ref(false);

const toggleDropdown = () => {
    isOpen.value = !isOpen.value;
};

const handleClickOutside = (event) => {
    if (dropdownContainer.value && !dropdownContainer.value.contains(event.target)) {
        isOpen.value = false;
    }
};

onMounted(() => {
    document.addEventListener('click', handleClickOutside);
});

onBeforeUnmount(() => {
    document.removeEventListener('click', handleClickOutside);
});

const onOuter = () => {
    // console.log('  onOuter : start');
    isOpen.value = !isOpen.value;
};
const onInner = (index) => {
    // console.log(index);
    // console.log('  onInner : start', index);
    // console.log('  onInner : liList[index]', props.liList[index]);
    isOpen.value = !isOpen.value;
    emit('onReturn', index);
    emit('update:current', props.liList[index]);
};
const onClose = () => {
    isOpen.value = false;
};
</script>

<style scoped lang="scss">
.innerDiv {
    max-height: 18vw;
    /* z-index: 1000; */
}
p {
    margin-bottom: 0;
}

.ulOpen {
    visibility: visible;
}

.ulClose {
    visibility: collapse;
}

.selectbox__background {
    position: fixed;
    bottom: 0;
    right: 0;
    width: 100vw;
    height: 100vh;
    z-index: 1;
}
.selectbox__disabled {
    cursor: not-allowed; // 비활성화 상태에서의 커서 스타일
}
.selectbox__p-disable {
    color: #ccc; // 비활성화 상태에서의 텍스트 색상
    cursor: not-allowed;
    border: 1px solid #f0f0f0; // 비활성화 상태에서의 배경색
}
</style>
